import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import * as api from './utils/api'

// Action Types
export const SET_MANDATES_LIST = 'mandates/SET_MANDATES_LIST'
export const SET_SINGLE_MANDATE = 'mandates/SET_SINGLE_MANDATE'
export const SET_MANDATES_LOADING = 'mandates/SET_MANDATES_LOADING'
export const SET_MANDATE_METRICS = 'mandates/SET_MANDATE_METRICS'

// Action Creators
export const setMandatesList = data => ({
  type: SET_MANDATES_LIST,
  payload: data,
})

export const setSingleMandate = data => ({
  type: SET_SINGLE_MANDATE,
  payload: data,
})

export const setMandatesLoading = loading => ({
  type: SET_MANDATES_LOADING,
  payload: loading,
})

export const setMandateMetrics = data => ({
  type: SET_MANDATE_METRICS,
  payload: data,
})

// Thunk Actions
export const getMandateMetrics = (params = {}) => async (dispatch, getState) => {
  try {
    const state = getState()
    const corporateId = params.corporateId || state?.auth?.corporateId
    const queryParams = corporateId ? { ...params, corporateId } : params

    const response = await api.getMandateMetrics(queryParams)
    if (response.message === 'Success' || response.success) {
      dispatch(setMandateMetrics(response.data))
    }
  } catch (error) {
    console.error('getMandateMetrics error:', error)
  }
}

export const getMandatesList = (params = {}) => async (dispatch, getState) => {
  try {
    dispatch(setMandatesLoading(true))
    
    // Get corporateId from Redux state if not provided in params
    const state = getState()
    const corporateId = params.corporateId || state?.auth?.corporateId
    
    // Add corporateId to params if available
    const queryParams = corporateId ? { ...params, corporateId } : params
    
    console.log('Fetching mandates with params:', queryParams)
    const response = await api.getMandates(queryParams)
    console.log('Mandates API response:', response)
    console.log('Response.success:', response.success)
    console.log('Response.message:', response.message)
    console.log('Response.data:', response.data)
    console.log('Response.data.result:', response.data?.result)
    console.log('Type of response.data:', typeof response.data)
    console.log('Is response.data an array?', Array.isArray(response.data))
    
    if (response.message === 'Success' || response.success) {
      console.log('SUCCESS - Dispatching to Redux:', response.data)
      dispatch(setMandatesList(response.data))
    } else {
      console.error('FAILED - API returned error:', response.message)
      ErrorMessage(response.message || 'Failed to fetch mandates')
      // Dispatch empty array on failure
      dispatch(setMandatesList([]))
    }
  } catch (error) {
    console.error('EXCEPTION - getMandatesList error:', error)
    console.error('Error stack:', error.stack)
    ErrorMessage('Error fetching mandates')
    dispatch(setMandatesList([]))
  } finally {
    dispatch(setMandatesLoading(false))
  }
}

export const getSingleMandate = mandateId => async dispatch => {
  try {
    dispatch(setMandatesLoading(true))
    const response = await api.getMandate(mandateId)
    if (response.success) {
      dispatch(setSingleMandate(response.data))
    } else {
      ErrorMessage(response.message || 'Failed to fetch mandate')
    }
  } catch (error) {
    ErrorMessage('Error fetching mandate')
    console.error('getSingleMandate error:', error)
  } finally {
    dispatch(setMandatesLoading(false))
  }
}

export const createNewMandate = data => async dispatch => {
  try {
    dispatch(setMandatesLoading(true))
    const response = await api.createMandate(data)
    const isSuccess = response.message && (!response.error || !response.error.message)
    if (isSuccess) {
      SuccessMessage(response.message || 'Mandate created successfully')
      dispatch(getMandatesList())
      dispatch(getMandateMetrics())
      return response.data
    } else {
      const errMsg = (response.error && response.error.message) || response.message || 'Failed to create mandate'
      ErrorMessage(errMsg)
      return null
    }
  } catch (error) {
    ErrorMessage('Error creating mandate')
    console.error('createNewMandate error:', error)
    return null
  } finally {
    dispatch(setMandatesLoading(false))
  }
}

export const updateExistingMandate = (mandateId, data) => async dispatch => {
  try {
    dispatch(setMandatesLoading(true))
    const response = await api.updateMandate(mandateId, data)
    const isSuccess = response.message && (!response.error || !response.error.message)
    if (isSuccess) {
      SuccessMessage(response.message || 'Mandate updated successfully')
      dispatch(getMandatesList())
      dispatch(getMandateMetrics())
      return response.data
    } else {
      const errMsg = (response.error && response.error.message) || response.message || 'Failed to update mandate'
      ErrorMessage(errMsg)
      return null
    }
  } catch (error) {
    ErrorMessage('Error updating mandate')
    console.error('updateExistingMandate error:', error)
    return null
  } finally {
    dispatch(setMandatesLoading(false))
  }
}

export const deleteExistingMandate = mandateId => async dispatch => {
  try {
    dispatch(setMandatesLoading(true))
    const response = await api.deleteMandate(mandateId)
    const isSuccess = response.message && (!response.error || !response.error.message)
    if (isSuccess) {
      SuccessMessage(response.message || 'Mandate deleted successfully')
      dispatch(getMandatesList())
      dispatch(getMandateMetrics())
      return true
    } else {
      const errMsg = (response.error && response.error.message) || response.message || 'Failed to delete mandate'
      ErrorMessage(errMsg)
      return false
    }
  } catch (error) {
    ErrorMessage('Error deleting mandate')
    console.error('deleteExistingMandate error:', error)
    return false
  } finally {
    dispatch(setMandatesLoading(false))
  }
}

export const updateMandateCounts = (mandateId, counts) => async dispatch => {
  try {
    const response = await api.updateMandateCounts(
      mandateId,
      counts.headcount,
      counts.joinedCount,
      counts.declinedCount,
      counts.maleCount,
      counts.femaleCount
    )
    const isSuccess = response.message && (!response.error || !response.error.message)
    if (isSuccess) {
      SuccessMessage(response.message || 'Counts updated successfully')
      dispatch(getMandatesList())
      dispatch(getMandateMetrics())
      return true
    } else {
      const errMsg = (response.error && response.error.message) || response.message || 'Failed to update counts'
      ErrorMessage(errMsg)
      return false
    }
  } catch (error) {
    ErrorMessage('Error updating counts')
    console.error('updateMandateCounts error:', error)
    return false
  }
}
